module.exports = __webpack_public_path__ + "static/media/pw.ecb48bb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pw.svg
// module id = 230
// module chunks = 0